/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, {useCallback, useState} from 'react'
import {useParams} from 'react-router-dom'
import {Modal} from 'react-bootstrap'
import {useIntl} from 'react-intl'
import {useFormik} from 'formik'
import * as Yup from 'yup'
import {
  IPropertiesRegistriesModel,
  propertiesRegistriesModelInitValues as initialValues,
} from '../models/PropertyRegistriesModel'
import axios from 'axios'
import Swal from 'sweetalert2'
import {KTSVG, toAbsoluteUrl} from '../../../../../../../../_metronic/helpers'
import {Input3} from '../../../../../../../../components/Forms/Input'
import {useDropzone} from 'react-dropzone'
import {AnimaBaixo} from '../../../../../../../../_metronic/assets/animation/styles'
import {useQueryClient} from 'react-query'

export interface UseOption {
  readonly value: string
  readonly label: string
  readonly color: string
  readonly isFixed?: boolean
  readonly isDisabled?: boolean
}

type Props = {
  show: boolean
  handleClose: () => void
  id: string
  data: any
}
const propertiesSchema = Yup.object().shape({})
const API_URL = process.env.REACT_APP_API_URL || 'api'

const ModalAddPropertyRegistries: React.FC<Props> = ({show, handleClose, id, data}) => {
  const intl = useIntl()
  const {uuid} = useParams()
  const [loading, setLoading] = useState(false)
  const [arquivo, setArquivo] = useState<any>([])
  let token = localStorage.getItem('auth_storage')
  const queryClient = useQueryClient()
  //BUSCA TOKEN NO LOCALSTORAGE
  if (token) token = token.replace(/['"]+/g, '')

  const onDrop = useCallback((acceptedFiles: any) => {
    setArquivo(acceptedFiles[0])
    //formik.setValues('path', acceptedFiles[0])
    // helpers3.setValue(acceptedFiles[0])
    //setActive(true)
    // eslint-disable-next-line
  }, [])

  const remove = (files: any) => {
    acceptedFiles.splice(files, 1)
  }

  const {getRootProps, getInputProps, isDragActive, acceptedFiles} = useDropzone({onDrop})

  const files = acceptedFiles.map((file: any) => (
    <AnimaBaixo key={file.path}>
      <p className='text-primary mt-10 dropzone'>
        <img alt='' className='w-30px me-3' src={toAbsoluteUrl('/media/svg/files/pdf.svg')} />
        {file.name} <span className='text-gray-600'>- {file.size} bytes</span>
      </p>
    </AnimaBaixo>
  ))

  //INICIO SUBMIT FORM
  const datasend = new FormData() //formdata object
  const formik = useFormik<IPropertiesRegistriesModel>({
    initialValues,
    validationSchema: propertiesSchema,
    onSubmit: async (values) => {
      setLoading(true)
      datasend.append('description', values.description || '')
      datasend.append('order', values.order || '')
      datasend.append('status', values.status || '')
      datasend.set('path', arquivo)
      try {
        await axios({
          method: 'post',
          url: `${API_URL}/sgt/v1/properties/${uuid}/registries`,
          data: datasend,
          headers: {
            Authorization: `Bearer ${token}`,
          },
        })
        setLoading(false)
        Swal.fire({
          icon: 'success',
          title: intl.formatMessage({id: 'PROPERTIES.SWAL_ADD'}),
          showConfirmButton: false,
          timer: 2000,
        })
        queryClient.invalidateQueries('property-registry-list-page=1&items_per_page=10')
        remove(files)
        formik.resetForm()
        handleClose()
      } catch (error) {
        Swal.fire({
          icon: 'error',
          title: intl.formatMessage({id: 'PROPERTIES.SWAL_ADD_ERROR'}),
          showConfirmButton: false,
          timer: 2000,
        })
        setLoading(false)
        formik.resetForm()
        remove(files)
        handleClose()
      }
    },
  })

  return (
    <Modal
      id={id}
      tabIndex={-1}
      aria-hidden='true'
      dialogClassName='modal-dialog-centered mw-600px h-auto'
      show={show}
      onHide={handleClose}
    >
      <div className='container-xxl p-5'>
        <div className='modal-header py-2 d-flex justify-align-content-between border-0'>
          {/* begin::Close */}
          <span className='fw-bold fs-4 '>Participação</span>
          <div className='btn btn-icon btn-sm btn-light-primary' onClick={handleClose}>
            <KTSVG className='svg-icon-2' path='/media/icons/duotune/arrows/arr061.svg' />
          </div>
          {/* end::Close */}
        </div>

        <div id='kt_account_profile_details' className='collapse show'>
          <form onSubmit={formik.handleSubmit} noValidate className='form'>
            <div className='card-body border-top p-9'>
              <div className='col-lg-12'>
                <div className='row'>
                  {/* INICIO NOME PORCENTAGEM */}
                  <div className='row mb-3'>
                    <Input3
                      title={intl.formatMessage({id: 'PROPERTY_REGISTRIES.ORDER'})}
                      placeholder={intl.formatMessage({id: 'PROPERTY_REGISTRIES.ORDER'})}
                      {...formik.getFieldProps('order')}
                    />
                    {/* FIM NOME PORCENTAGEM */}

                    {/* INICIO DESCRIÇÃO */}
                  </div>

                  <div className='row mb-3'>
                    <label className='col-lg-12 col-form-label required fw-bold fs-6'>
                      {intl.formatMessage({id: 'COMMON.STATUS'})}
                    </label>
                    <select
                      className='form-select form-select-solid form-select-lg fw-bold'
                      {...formik.getFieldProps('status')}
                    >
                      <option value='active'>
                        {intl.formatMessage({id: 'PROPERTY_REGISTRIES.STATUS_ACTIVE'})}
                      </option>
                      <option value='replaced'>
                        {intl.formatMessage({id: 'PROPERTY_REGISTRIES.STATUS_REPLACED'})}
                      </option>
                    </select>
                  </div>

                  <div className='row mb-3'>
                    <label className='col-lg-12 col-form-label required fw-bold fs-6'>
                      {intl.formatMessage({id: 'COMMON.DESCRIPTION'})}
                    </label>

                    <textarea
                      className='form-control form-control-lg form-control-solid'
                      title={intl.formatMessage({id: 'COMMON.DESCRIPTION'})}
                      placeholder={intl.formatMessage({id: 'COMMON.DESCRIPTION'})}
                      {...formik.getFieldProps('description')}
                    />
                  </div>
                  {/* FIM DESCRIÇÃO */}
                  <div className='row mb-3'>
                    <label className='col-lg-12 col-form-label required fw-bold fs-6'>
                      {intl.formatMessage({id: 'COMMON.DOCUMENT'})}
                    </label>
                    <div className='dropzone' {...getRootProps()}>
                      <div className='dz-message needsclick'>
                        <i className='bi bi-file-earmark-arrow-up text-primary fs-3x'></i>
                        <div className='ms-4'>
                          <input {...getInputProps()} />
                          {isDragActive ? (
                            <h3 className='fs-5 fw-bold text-gray-900 mb-1'>
                              {intl.formatMessage({id: 'DROPZONE.TITLE_DRAG'})}
                            </h3>
                          ) : (
                            <h3 className='fs-5 fw-bold text-gray-900 mb-1'>
                              {intl.formatMessage({id: 'DROPZONE.COMMON_TITLE'})}
                            </h3>
                          )}

                          <label
                            htmlFor='license_documentation'
                            className='fs-7 fw-semibold text-gray-400'
                          >
                            {intl.formatMessage({id: 'DROPZONE.SUBTITLE'})}
                          </label>
                        </div>
                      </div>

                      <p> {files}</p>
                    </div>
                  </div>

                  {/* Submit */}
                  <div className='d-flex justify-content-end py-6'>
                    <button type='submit' className='btn btn-primary' disabled={loading}>
                      {!loading && intl.formatMessage({id: 'COMMON.SAVE_BUTTON'})}
                      {loading && (
                        <span className='indicator-progress' style={{display: 'block'}}>
                          {intl.formatMessage({id: 'COMMON.SAVING_BUTTON'})}{' '}
                          <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                        </span>
                      )}
                    </button>
                  </div>
                </div>
                {/* ----------------------------------------------------------------------------------- */}
              </div>
            </div>
          </form>
        </div>
      </div>
    </Modal>
  )
}

export {ModalAddPropertyRegistries}
